const reports = [
    { name: "Bank Estimation Report", status: "available" },
    { name: "Measurement Report", status: "available" },
    { name: "PWD Estimate with Rate Analysis Report", status: "coming" },
  ];
  export default reports;